<div class="balloon">
    <p>Install this webapp on your iPhone: tap<img src="assets/img/apple-share.svg" alt="share icon">and then 
        <span class="ion-ios-add">Add to homescreen</span></p>
</div>